import type { MakeCall } from '../createMakeCall';
import { QualificationRequirement } from '../types/qualifications/QualificationRequirement';
import { RequiredDocuments } from '../types/RequiredDocuments';

const updateQualificationRequirementsByListing =
  (makeCall: MakeCall) =>
  (listingUuid: string, data: Array<RequiredDocuments>) =>
    makeCall<QualificationRequirement>(
      'PUT',
      `/api/v2/qualification/requirements/by-listing/${listingUuid}`,
      {
        data: {
          documents: data,
        },
      },
    );
export { updateQualificationRequirementsByListing };
